import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URL } from './base-url';

@Injectable({
  providedIn: 'root'
})
export class JobPortalService {

  constructor(public http: HttpClient) { }

  base_URL = BASE_URL;

  uploadImage(file:any){
    console.log(file)
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(this.base_URL+'upload-file/uploadFile?cid='+sessionStorage.getItem('cid'),formData)
  }

  addCountryCode(body:any){
    return this.http.post(this.base_URL+'countryCodeMaster',body)
  }

  getAllCountryCode(){
    return this.http.get(this.base_URL+'countryCodeMaster/all/'+sessionStorage.getItem('cid'))
  }

  getCountryCodeById(countryCodeMasterId:any){
    return this.http.get(this.base_URL+'countryCodeMaster/'+countryCodeMasterId+'/'+sessionStorage.getItem('cid'))
  }

  deleteCountryCode(id:any){
    return this.http.delete(this.base_URL+'countryCodeMaster/hardDelete/'+id)
  }

  updateCountryCode(body:any){
    return this.http.put(this.base_URL+'countryCodeMaster/update',body)
  }

  addExperience(body:any){
    return this.http.post(this.base_URL+'experience',body)
  }

  getAllExperience(){
    return this.http.get(this.base_URL+'experience/all/'+sessionStorage.getItem('cid'))
  }

  getExperienceById(experienceId:any){
    return this.http.get(this.base_URL+'experience/'+experienceId+'/'+sessionStorage.getItem('cid'))
  }

  deleteExperience(id:any){
    return this.http.delete(this.base_URL+'experience/hardDelete/'+id)
  }

  updateExperience(body:any){
    return this.http.put(this.base_URL+'experience/update',body)
  }

  addEducation(body:any){
    return this.http.post(this.base_URL+'education',body)
  }

  getAllEducation(){
    return this.http.get(this.base_URL+'education/all/'+sessionStorage.getItem('cid'))
  }

  getEducationById(educationId:any){
    return this.http.get(this.base_URL+'education/'+educationId+'/'+sessionStorage.getItem('cid'))
  }

  deleteEducation(id:any){
    return this.http.delete(this.base_URL+'education/hardDelete/'+id)
  }

  updateEducation(body:any){
    return this.http.put(this.base_URL+'education/update',body)
  }

  addIndustry(body:any){
    return this.http.post(this.base_URL+'industry',body)
  }

  getAllIndustry(){
    return this.http.get(this.base_URL+'industry/all/'+sessionStorage.getItem('cid'))
  }

  getIndustryById(industryId:any){
    return this.http.get(this.base_URL+'industry/'+industryId+'/'+sessionStorage.getItem('cid'))
  }

  deleteIndustry(id:any){
    return this.http.delete(this.base_URL+'industry/hardDelete/'+id)
  }

  updateIndustry(body:any){
    return this.http.put(this.base_URL+'industry/update',body)
  }

  addFAQ(body:any){
    return this.http.post(this.base_URL+'faq',body)
  }

  getAllFAQ(){
    return this.http.get(this.base_URL+'faq/all/'+sessionStorage.getItem('cid'))
  }

  getFAQById(faqId:any){
    return this.http.get(this.base_URL+'faq/'+faqId+'/'+sessionStorage.getItem('cid'))
  }

  deleteFAQ(id:any){
    return this.http.delete(this.base_URL+'faq/hardDelete/'+id)
  }

  updateFAQ(body:any){
    return this.http.put(this.base_URL+'faq/update',body)
  }


  addJobTitle(body:any){
    return this.http.post(this.base_URL+'jobTitle',body)
  }

  getAllJobTitle(){
    return this.http.get(this.base_URL+'jobTitle/all/'+sessionStorage.getItem('cid'))
  }

  getJobTitleById(jobTitleId:any){
    return this.http.get(this.base_URL+'jobTitle/'+jobTitleId+'/'+sessionStorage.getItem('cid'))
  }

  deleteJobTitle(id:any){
    return this.http.delete(this.base_URL+'jobTitle/hardDelete/'+id)
  }

  updateJobTitle(body:any){
    return this.http.put(this.base_URL+'jobTitle/update',body)
  }


  addLanguage(body:any){
    return this.http.post(this.base_URL+'language',body)
  }

  getAllLanguage(){
    return this.http.get(this.base_URL+'language/all/'+sessionStorage.getItem('cid'))
  }

  getLanguageById(languageId:any){
    return this.http.get(this.base_URL+'language/'+languageId+'/'+sessionStorage.getItem('cid'))
  }

  deleteLanguage(id:any){
    return this.http.delete(this.base_URL+'language/hardDelete/'+id)
  }

  updateLanguage(body:any){ 
    return this.http.put(this.base_URL+'language/update',body)
  }

  addLocation(body:any){
    return this.http.post(this.base_URL+'location',body)
  }

  getAllLocation(){
    return this.http.get(this.base_URL+'location/all/'+sessionStorage.getItem('cid'))
  }

  getLocationById(locationId:any){
    return this.http.get(this.base_URL+'location/'+locationId+'/'+sessionStorage.getItem('cid'))
  }

  deleteLocation(id:any){
    return this.http.delete(this.base_URL+'location/hardDelete/'+id)
  }

  updateLocation(body:any){
    return this.http.put(this.base_URL+'location/update',body)
  }

  getLocationByWildSearch(wildSearch:any){
    return this.http.get(this.base_URL+'location/wildSearch/'+wildSearch+"/"+sessionStorage.getItem('cid'))
  }

  addSkill(body:any){
    return this.http.post(this.base_URL+'skill',body)
  }

  getAllSkill(){
    return this.http.get(this.base_URL+'skill/all/'+sessionStorage.getItem('cid'))
  }

  getSkillById(skillId:any){
    return this.http.get(this.base_URL+'skill/'+skillId+'/'+sessionStorage.getItem('cid'))
  }

  deleteSkill(id:any){
    return this.http.delete(this.base_URL+'skill/hardDelete/'+id)
  }

  UpdateSkill(body:any){
    return this.http.put(this.base_URL+'skill/update',body)
  }
  jobPostingForAdmin(body:any){
    return this.http.post(this.base_URL+'jobPosting/insertForAdmin',body)
  }

  addJob(body:any) {
    return this.http.post(this.base_URL+'jobPosting',body)
  }

  addHomePageJobPosting(body:any) {
    return this.http.post(this.base_URL+'homePageJobPosting',body)
  }

  jobPostinghardDelete(id:any){
    return this.http.delete(this.base_URL+'jobPosting/hardDelete/'+id)
  }

  homePageJobPostingDelete(id:any){
    return this.http.delete(this.base_URL+'homePageJobPosting/hardDelete/'+id)
  }

  updateJob(body:any) {
    return this.http.put(this.base_URL+'jobPosting/update',body)
  }

  jobUpdateForAdmin(body:any)
  {
    return this.http.put(this.base_URL+'jobPosting/update',body)
  }
  getJobPostingById(id:any)
  {
    return this.http.get(this.base_URL+'jobPosting/'+id+'/'+sessionStorage.getItem('cid'))
  }

  getHomePageJobPostingById(id:any)
  {
    return this.http.get(this.base_URL+'homePageJobPosting/'+id+'/'+sessionStorage.getItem('cid'))
  }

  getAllJobPosting(pageNumber:any,recordsPerPage:any){
    return this.http.get(this.base_URL+'jobPosting/all/'+sessionStorage.getItem('cid')+'/'+pageNumber+'/'+recordsPerPage)
  }

  getAllHomePageJobPosting(pageNumber:any,recordsPerPage:any){
    return this.http.get(this.base_URL+'homePageJobPosting/all/'+sessionStorage.getItem('cid')+'/'+pageNumber+'/'+recordsPerPage)
  }
  
  addNoticePeriod(body:any){
    return this.http.post(this.base_URL+'noticePeriod',body)
  }

  getAllNoticePeriod(){
    return this.http.get(this.base_URL+'noticePeriod/all/'+sessionStorage.getItem('cid'))
  }

  getNoticePeriodById(noticePeriodId:any){
    return this.http.get(this.base_URL+'noticePeriod/'+noticePeriodId+'/'+sessionStorage.getItem('cid'))
  }

  UpdateNoticePeriod(body:any){
    return this.http.put(this.base_URL+'noticePeriod/update',body)
  }

  deleteNoticePeriod(id:any){
    return this.http.delete(this.base_URL+'noticePeriod/hardDelete/'+id)
  }

  addCompanyProfile(body:any){
    return this.http.post(this.base_URL+'companyProfile',body)
  }

  getCompanyProfile(pageNumber:any,recordsPerPage:any){
    return this.http.get(this.base_URL+'companyProfile/all/'+sessionStorage.getItem('cid')+'/'+pageNumber+'/'+recordsPerPage)
  }

  getAllCompanyProfileWithoutPagination(){
    return this.http.get(this.base_URL+'companyProfile/allWithoutPagination/'+sessionStorage.getItem('cid'))
  }


  getCompanyProfileById(noticePeriodId:any){
    return this.http.get(this.base_URL+'companyProfile/'+noticePeriodId+'/'+sessionStorage.getItem('cid'))
  }

  UpdateCompanyProfile(body:any){
    return this.http.put(this.base_URL+'companyProfile/update',body)
  }

  deleteCompanyProfile(id:any){
    return this.http.delete(this.base_URL+'companyProfile/hardDelete/'+id)
  }

  addCompanyRecruiter(body:any){
    return this.http.post(this.base_URL+'companyRecruiter',body)
  }

  getAllCompanyRecruiter(){
    return this.http.get(this.base_URL+'companyRecruiter/all/'+sessionStorage.getItem('cid'))
  }

  getCompanyRecruiterById(noticePeriodId:any){
    return this.http.get(this.base_URL+'companyRecruiter/'+noticePeriodId+'/'+sessionStorage.getItem('cid'))
  }

  UpdateCompanyRecruiter(body:any){
    return this.http.put(this.base_URL+'companyRecruiter/update',body)
  }

  deleteCompanyRecruiter(id:any){
    return this.http.delete(this.base_URL+'companyRecruiter/hardDelete/'+id)
  }

  addClientLogo(body:any){
    return this.http.post(this.base_URL+'clientLogo',body)
  }

  addContactUs(body:any){
    return this.http.post(this.base_URL+'contactUs',body)
  }

  updateClientLogo(body:any){
    return this.http.put(this.base_URL+'clientLogo/update',body)
  }

  updateContactUs(body:any){
    return this.http.put(this.base_URL+'contactUs/update',body)
  }

  getClientLogo(){
    return this.http.get(this.base_URL+'clientLogo/all/'+sessionStorage.getItem('cid'))
  }

  getContactUs(){
    return this.http.get(this.base_URL+'contactUs/all/'+sessionStorage.getItem('cid'))
  }

  addRefCustomerLogo(body:any){
    return this.http.post(this.base_URL+'refCustomerLogo',body)
  }

  getAllRefCustomerLogo(){
    return this.http.get(this.base_URL+'refCustomerLogo/all/'+sessionStorage.getItem('cid'))
  }

  getRefCustomerLogoById(refCustomerLogoId:any){
    return this.http.get(this.base_URL+'refCustomerLogo/'+refCustomerLogoId+'/'+sessionStorage.getItem('cid'))
  }

  deleteRefCustomerLogo(id:any){
    return this.http.delete(this.base_URL+'refCustomerLogo/hardDelete/'+id)
  }

  addTestimonial(body:any){
    return this.http.post(this.base_URL+'testimonial',body)
  }

  getAllTestimonial(){
    return this.http.get(this.base_URL+'testimonial/all/'+sessionStorage.getItem('cid'))
  }

  getTestimonialById(testimonialId:any){
    return this.http.get(this.base_URL+'testimonial/'+testimonialId+'/'+sessionStorage.getItem('cid'))
  }

  deleteTestimonial(id:any){
    return this.http.delete(this.base_URL+'testimonial/hardDelete/'+id)
  }

  addHackathones(body:any){
    return this.http.post(this.base_URL+'hackathones',body)
  }

  getAllHackathones(){
    return this.http.get(this.base_URL+'hackathones/all/'+sessionStorage.getItem('cid'))
  }

  getHackathonesById(hackathonesId:any){
    return this.http.get(this.base_URL+'hackathones/'+hackathonesId+'/'+sessionStorage.getItem('cid'))
  }

  deleteHackathones(id:any){
    return this.http.delete(this.base_URL+'hackathones/hardDelete/'+id)
  }

  addCompanyNews(body:any){
    return this.http.post(this.base_URL+'companyNews',body)
  }

  getAllCompanyNews(){
    return this.http.get(this.base_URL+'companyNews/all/'+sessionStorage.getItem('cid'))
  }

  getCompanyNewsById(companyNewsId:any){
    return this.http.get(this.base_URL+'companyNews/'+companyNewsId+'/'+sessionStorage.getItem('cid'))
  }

  deleteCompanyNews(id:any){
    return this.http.delete(this.base_URL+'companyNews/hardDelete/'+id)
  }

  getCompanyDetailsByRecruiterPhone(phone:any) {
    return this.http.get(this.base_URL+'companyRecruiter/getCompanyDetailsByRecruiterPhone/'+phone+'/'+localStorage.getItem('cid'))
  }

  addPrivacyPolicy(body:any){
    return this.http.post(this.base_URL+'privacyPolicy',body)
  }

  updatePrivacyPolicy(body:any){
    return this.http.put(this.base_URL+'privacyPolicy/update',body)
  }

  getPrivacyPolicy(){
    return this.http.get(this.base_URL+'privacyPolicy/all/'+sessionStorage.getItem('cid'))
  }

  addAboutUs(body:any){
    return this.http.post(this.base_URL+'aboutUs',body)
  }

  updateAboutUs(body:any){
    return this.http.put(this.base_URL+'aboutUs/update',body)
  }

  getAboutUs(){
    return this.http.get(this.base_URL+'aboutUs/all/'+sessionStorage.getItem('cid'))
  }


}
